import React from 'react'
import './services.css'
import { AiOutlineCheckCircle } from 'react-icons/ai'

export default function Services() {
  return (
    <section id='services'>
      <h5>Ce que j'offre</h5>
      <h2>Services</h2>
      <div className='container services_container'>
        <article className='service'>
          <div className='service_head'>
            <h3>UI/UX Design 2ans+</h3>
          </div>
          <ul className='service_list'>
            <li>
              <AiOutlineCheckCircle className='service_list-icon'></AiOutlineCheckCircle>
              <p>Le design des interfaces de vos applications mobiles</p>
            </li>
            <li>
              <AiOutlineCheckCircle className='service_list-icon'></AiOutlineCheckCircle>
              <p>Le design des interfaces de vos applications webs</p>
            </li>
            <li>
              <AiOutlineCheckCircle className='service_list-icon'></AiOutlineCheckCircle>
              <p>
                La créaton des affiches, cartes de visites, catalogues, des
                logos etc...
              </p>
            </li>
          </ul>
        </article>
        {/* End of ui/ux */}
        <article className='service'>
          <div className='service_head'>
            <h3>Developpement Web</h3>
          </div>
          <ul className='service_list'>
            <li>
              <AiOutlineCheckCircle className='service_list-icon'></AiOutlineCheckCircle>
              <p>
                La créaton de vos sites web pour vos business et entreprises
              </p>
            </li>
            <li>
              <AiOutlineCheckCircle className='service_list-icon'></AiOutlineCheckCircle>
              <p>
                Nous avons réalisés pleins de sites web pour nos clients, un ste
                e-commerce
              </p>
            </li>
            <li>
              <AiOutlineCheckCircle className='service_list-icon'></AiOutlineCheckCircle>
              <p>La création des applications mobiles</p>
            </li>
          </ul>
        </article>
        {/* End of ui/ux */}
        <article className='service'>
          <div className='service_head'>
            <h3>Tarifications</h3>
          </div>
          <ul className='service_list'>
            <li>
              <AiOutlineCheckCircle className='service_list-icon'></AiOutlineCheckCircle>
              <p>
                Pour toutes idées sur les tarifications de mes services
                contactez moi sur: <br />
                +212680227410 manguemasysylla13@gmail.com Vous pouvez tout de
                même m'envoyez un message à travers le formulaire d'en bas.
              </p>
            </li>
          </ul>
        </article>
        {/* End of ui/ux */}
      </div>
    </section>
  )
}
